import * as React from 'react'

import { Button } from 'packages/common'

import { TicketStatus } from 'app/fieldapp/store/tickets'

import { Section } from '../TicketDetail.styles'
import { useTicketStatus } from './useTicketStatus'

type StatusSectionProps = {
  status: TicketStatus
  ticketId: string
}

export const StatusSection: React.FC<StatusSectionProps> = ({
  ticketId,
  status,
}) => {
  const { text, onClick, disabled, loading } = useTicketStatus(ticketId, status)

  return (
    <Section>
      <Button
        block={true}
        disabled={disabled}
        isLoading={loading}
        onClick={onClick}
        buttonType={'utility'}
      >
        {text}
      </Button>
    </Section>
  )
}
